import React from 'react'
import { useKlarna } from 'lib/core/hooks'
import { Spinner } from 'lib/ui'
import { Container } from './styled'

export const Klarna = () => {
  const { isLoading, clientToken, paymentMethodCategory, KlarnaWidget } = useKlarna()

  return (
    <Container>
      <div>
        {isLoading ? (
          <Spinner />
        ) : (
          <KlarnaWidget
            clientToken={clientToken ?? ''}
            paymentMethodCategory={paymentMethodCategory ?? ''}
          />
        )}
      </div>
    </Container>
  )
}
